<template>
  <div class="list-box">
    <div class="top">
      <div class="footer-box" ref="footer">
        <div :ref="'footer' + item.index" v-for="item in rounds" :key="item.index + (item.id || '')" class="item"
          :class="{ selected: item.index + item.id === currentRound + id }"
          @click="goRound(item.index, item.id, item.stages)">{{ item.name }}</div>
      </div>
    </div>
    <div class="list" v-if="getList.length > 0">
      <div class="item" v-for="(item, i) in getList" :key="i">
        <div class="time" v-if="getDateTitle(i)">{{ getDate(item.beginDate, '{y}年{m}月{d}日') }} {{ getDate(item.beginDate,
          '周{a}') }}</div>
        <div v-else class="time"></div>
        <div class="flex-center title-box" v-if="item.name || item.fieldName">
          <div class="isChampionGame">{{ item.name || '' }}</div>
          <div>{{item.fieldName || ''}}</div>
        </div>
        <div class="games">
          <div class="info">
            <div class="flex-center" style="border-bottom: 1px solid rgb(238, 238, 238);">
              <div class="delete" v-if="isDelete">
                <van-checkbox checked-color="red" v-model="deleteList[i].checkbox"
                  @change="changeCheckbox(i, item.id)"></van-checkbox>
              </div>
              <div class="state" :style="{ color: getDate(item.beginDate, '{h}:{i}') === '待定' ? '#8C8C8C' : '#191919' }">
                {{ getDate(item.beginDate, '{h}:{i}') }}
                <!-- <div class="isChampionGame" v-if="item.name">{{ item.name }}</div> -->
              </div>
              <div class="team">
                <div>
                  <img :src="imageView(item.homeTeam.badge, 40, 40)" v-if="item.homeTeam.badge" />
                  <img src="https://images.snsports.cn/FrB9e_-z4Gj4879NuraIWmiVDkv_" v-else />
                  <span class="overflow-text" :class="item.homeTeam.id === '-1' ? 'span' : ''">{{ item.homeTeam.id === '-1'
                    ? '待定' : item.homeTeam.name }}</span>
                </div>
                <div>
                  <img :src="imageView(item.awayTeam.badge, 40, 40)" v-if="item.awayTeam.badge" />
                  <img src="https://images.snsports.cn/FrB9e_-z4Gj4879NuraIWmiVDkv_" v-else />
                  <span class="overflow-text" :class="item.homeTeam.id === '-1' ? 'span' : ''">{{ item.awayTeam.id === '-1'
                    ? '待定' : item.awayTeam.name }}</span>
                </div>
              </div>
              <div class="date" v-if="item.homeScore === -1 && item.awayScore === -1">
                <span v-if="item.beginDate">{{ new Date(item.beginDate) > new Date() ? '未开始' : '未录入比分' }}</span>
                <span v-else>未设置开赛时间</span>
              </div>
              <div class="date" v-else>
                <div>{{ item.homeScore === -1 ? '未录入比分' : item.homeScore }}</div>
                <div>{{ item.awayScore === -1 ? '未录入比分' : item.awayScore }}</div>
              </div>
            </div>
          </div>
          <div class="but">
            <div v-if="item.homeTeam.id !== '-1' && item.awayTeam.id !== '-1' && sportType !== '棒球'"
              @click="goStatistics(item.id)">技术统计</div>
            <div v-else style="background-color: rgba(0, 0, 0, 0);"></div>
            <div v-if="item.homeTeam.id !== '-1' && item.awayTeam.id !== '-1'" @click="scoreEntry(item.id)">比分录入</div>
            <div v-else style="background-color: rgba(0, 0, 0, 0);"></div>
            <div @click="updateGame(item.id)">编辑比赛</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <van-empty description="暂无数据" />
    </div>
    <div class="footer">
      <div class="flex-center" style="width: 100%;" v-if="!isDelete">
        <div class="delete div" @click="isDelete = true">批量删除</div>
        <div class="create div" @click="createGame">创建比赛</div>
      </div>
      <div class="flex-center" v-else>
        <div class="delete div" @click="cancel">取消</div>
        <div class="delete2 div" @click="deleteGame">批量删除</div>
      </div>
    </div>
    <van-dialog id="van-dialog" />
  </div>
</template>

<script>
import {
  getBMStageGamesByBMMatchId,
  adminGetBMMatchStageGameList,
  adminDeleteBMMatchGame
} from "@/api/match"; // adminDeleteBMMatchGame
import { DateUtil, QNImageUtil } from '@/utils'
import { Popup, Stepper, Toast, Checkbox, Dialog, Empty } from 'vant'
import Vue from 'vue'
Vue.use(Popup).use(Stepper).use(Toast).use(Checkbox).use(Dialog).use(Empty)
export default {
  data() {
    return {
      matchId: null,
      active: 1,
      isGroupRound: '',
      round: '',
      clothPrefix: 'qy_',
      list: [],
      activityList: [],
      maxRound: '',
      rounds: [],
      currentRound: '',
      match: {},
      id: null,
      teamObj: {
        homeTeamName: '',
        awayTeamName: '',
        homeScore: '',
        awayScore: '',
        round: 1,
        index: 0
      },
      isDelete: false,
      deleteList: [],
      stages: 0,
      unionMatchId: '',
      sportType: ''
    };
  },
  mounted() {
    this.$store.dispatch('changeDispatch', {});
    this.matchId = this.$route.query.matchId
    if(this.$route.query.round && this.$route.query.stages && this.$route.query.roundId){
      // this.id = this.$route.query.id
      this.goRound(this.$route.query.round, this.$route.query.roundId, this.$route.query.stages)
    } else {
      this.getBMGamesByBMMatchId(1)
    }
  },
  computed: {
    getList() {
      const index = this.currentRound - 1
      const list = this.list[index] && this.list[index].games || []
      return list
    }
  },
  watch: {
    getList: {
      handler() {
        this.deleteList = []
        for (let index = 0; index < this.getList.length; index++) {
          this.deleteList.push({ checkbox: false, id: '' })
        }
      }
    }
  },
  methods: {
    getBMGamesByBMMatchId(i) {
      const obj = {
        matchId: this.matchId,
        isGroupRound: this.isGroupRound,
        round: this.round,
        stageId: this.id
      }
      if (i === 1) {
        delete obj.isGroupRound
        delete obj.round
      }
      if (this.id) {
        delete obj.isGroupRound
      }
      getBMStageGamesByBMMatchId(obj).then(res => {
        const data = res.data
        const match = data.match
        var games = data.games
        this.maxRound = data.maxRound || match.roundCount + match.knockoutRoundCount
        this.isGroupRound = (typeof data.isGroupRound === 'undefined' ? 1 : data.isGroupRound)
        this.currentRound = data.round
        this.sportType = match.sportType || ''
        if (match.sportType === '篮球') {
          this.clothPrefix = 'basket_'
        }
        this.match = match
        for (var i = 0; i < games.length; i++) {
          if (games.gameNotBegin === 1) {
            games[i].gameStatus = '未开始'
          } else if (games.gameEnd === 0) {
            games[i].gameStatus = '进行中'
          } else {
            games[i].gameStatus = '已结束'
          }
          games[i].order = i + 1
        }
        var rounds = []
        if (data.stages && data.stages.length >= 1) {
          data.stages.forEach((item, index) => {
            for (let i = 1; i <= item.roundCount; i++) {
              rounds.push({
                index: i,
                id: item.id,
                stages: index,
                name: item.stageName + '第' + i + '轮'
              })
            }
          })
          if (!this.id) {
            const r = rounds.find(r => r.index === this.currentRound)
            this.id = r?.id
          }
        } else {
          for (let i = 1; i <= this.maxRound; i++) {
            var isGroupRound = i <= match.roundCount
            var round = isGroupRound ? i : i - match.roundCount
            rounds.push({
              index: i,
              name: this.getDefaultRoundDescription(isGroupRound, round, match)
            })
          }
        }
        this.rounds = rounds
        console.log(rounds);
        // this.$nextTick(() => {
        //   const footer = this.$refs.footer;
        //   const scrollLeft = this.$refs['footer' + this.currentRound] && this.$refs['footer' + this.currentRound][0].offsetLeft || 0
        //   footer.scrollLeft = scrollLeft - 100
        // })
        this.adminGetBMMatchStageGameList()
      })
    },
    groupGames(games) {
      const result = {}
      games.forEach((item) => {
        const time = new Date(item.beginDate).toLocaleDateString();
        if (!result[time]) {
          result[time] = { time, games: [] };
        }
        result[time].games.push(item);
      });
      Object.values(result).forEach((item) => {
        item.games.sort((a, b) => new Date(a.beginDate) - new Date(b.beginDate));
      });
      const list = Object.values(result)
      list.sort((a, b) => new Date(a.time) - new Date(b.time))
      return list
    },
    getDefaultRoundDescription(isGroupRound, round, match) {
      var description = ''
      if (!isGroupRound) {
        if (round > match.knockoutRoundCount) { // 理论上，此时round是不可能大于knockoutRoundCount的
          round = match.knockoutRoundCount// 修正Server端的数据异常，提高容错性。
        }
        if (round === match.knockoutRoundCount) {
          description = '决赛'
        } else if (round === match.knockoutRoundCount - 1) {
          description = '半决赛'
        } else {
          description = '1/' + Math.pow(2, match.knockoutRoundCount - round) + '决赛'
        }
      } else {
        if (round > match.roundCount) { // 理论上，此时round是不可能大于roundCount的
          round = match.roundCount// 修正Server端的数据异常，提高容错性。
        }
        var prefix = match.type === 'cup' ? '小组赛 ' : ''
        description = prefix + '第' + round + '轮'
      }
      return description
    },
    goRound(round, id, index) {
      console.log(round, id, index);
      
      this.stages = index
      this.id = id || null
      var match = this.match
      if (match.type === 'cup') {
        this.isGroupRound = round <= match.roundCount ? 1 : 0
      }
      if (this.id === null) {
        this.round = (round <= match.roundCount ? round : round - match.roundCount)
      } else {
        this.round = round
      }

      // if (this.id) {
      //   let num = this.rounds.findIndex(item => item.stages === index && item.index === round)
      //   this.$nextTick(() => {
      //     this.$refs.footer.scrollLeft = this.$refs.footer.scrollWidth / this.rounds.length * num - (this.$refs.footer.clientWidth / 2)
      //   })
      // } else {
      //   this.$nextTick(() => {
      //     this.$refs.footer.scrollLeft = this.$refs.footer.scrollWidth / this.rounds.length * round - (this.$refs.footer.clientWidth / 2)
      //   })
      // }
      this.getBMGamesByBMMatchId()
    },
    getDate(value, type) {
      if (!value) return '待定'
      return DateUtil.parseDateTime(value, type)
    },
    getDateTitle(i) {
      if (i === 0) return true
      const beginDate1 = this.getDate(this.getList[i].beginDate, '{y}年{m}月{d}日')
      const beginDate2 = this.getDate(this.getList[i - 1].beginDate, '{y}年{m}月{d}日')
      if (beginDate1 === beginDate2) return false
      return true
    },
    adminGetBMMatchStageGameList() {
      adminGetBMMatchStageGameList({ matchId: this.matchId, stageId: this.id }).then(res => {
        const data = res.data
        this.list = data.rounds
      })
    },
    scoreEntry(id) {
      if (this.sportType === '棒球') {
        this.$router.push('/match-manage/baseball-score/' + id + '?matchId=' + this.matchId)
      } else if (this.sportType === '网球') {
        this.$router.push(`/match-manage/tennis-score?gameId=${id}`)
      } else {
        this.$router.push(
          {
            path: `/match-manage/score-entry/${this.$route.params.unionMatchId}`, query: {
              matchId: this.matchId,
              id
            }
          })
      }
    },
    updateGame(id) {
      this.$router.push({
        path: '/match-manage/create-game', query: {
          matchId: this.matchId,
          id,
          round: this.round,
          stages: this.stages,
          roundId: this.id,
          unionMatchId: this.$route.params.unionMatchId
        }
      })
    },
    createGame() {
      this.$router.push({
        path: '/match-manage/create-game', query: {
          matchId: this.matchId,
          round: this.round,
          stages: this.stages,
          roundId: this.id,
          unionMatchId: this.$route.params.unionMatchId
        }
      })
    },
    imageView(img, w, h) {
      return QNImageUtil.imageView(img, w, h)
    },
    cancel() {
      this.deleteList.forEach(item => {
        item.checkbox = false
        item.id = ''
      })
      this.isDelete = false
    },
    changeCheckbox(i, id) {
      this.deleteList[i].id = id
    },
    deleteGame() {
      const bol = this.deleteList.some(item => item.id !== '')
      if (!bol) return Toast('请先选择比赛')
      Dialog.confirm({
        title: '提示',
        message: '删除后无法恢复',
      }).then(() => {
        const list = []
        for (let index = 0; index < this.deleteList.length; index++) {
          const id = this.deleteList[index].id
          if (id) {
            let p = new Promise((resolve, reject) => {
              adminDeleteBMMatchGame({ id }).then((res) => {
                resolve(res)
              }).catch(e => {
                reject(e)
              })
            })
            list.push(p)
          }
        }
        Promise.all([...list]).then(results => {
          console.log('success:', results)
          Toast('删除成功！')
          this.isDelete = false
          this.goRound(this.round, this.id, this.stages)
        }).catch(e => { // 失败的时候则返回最先被reject失败状态的值
          console.log("error", e)
        })
      }).catch(() => {
        console.log('2');
      })
    },
    goStatistics(id) {
      if (this.sportType === '足球') {
        this.$router.push({
          path: `/match-manage/football-statistics`,
          query: {
            matchId: this.matchId,
            id
          }
        })
      } else if (this.sportType === '网球') {
        this.$router.push({
          path: `/match-manage/tennis-statistics`,
          query: {
            matchId: this.matchId,
            gameId: id
          }
        })
      } else {
        this.$router.push(
          {
            path: `/match-manage/game-statistics`, query: {
              matchId: this.matchId,
              id
            }
          })
      }
    }
  },
};
</script>

<style scoped lang="scss">
.list-box {
  padding-top: 56px;
  padding-bottom: 100px;

  .list {
    background: #fff;

    .item {
      .time {
        background: #F6F6F8;
        font-weight: 500;
        font-size: 12px;
        padding: 16px;
        color: #8C8C8C;
      }

      .info {
        background: #FCFCFD;
        padding: 12px 16px;
        padding-bottom: 6px;
        border-radius: 4px 4px 0px 0px;

        .delete {
          margin-right: 12px;

          ::v-deep .van-checkbox__icon .van-icon {
            border-color: red;
          }
        }
      }
      .title-box{
        font-size: 13px;
        color: #333;
        padding: 12px 16px;
        // padding-top: 12px;
        border-bottom: 1px solid #E5E5E5;
      }

      .games {
        padding: 0 16px;
        background: #fff;

        .state {
          margin-right: 16px;
          font-size: 14px;
          width: 80px;

          .isChampionGame {
            width: 24px;
            background: #1565FC;
            border-radius: 2px;
            text-align: center;
            padding: 2px 6px;
            color: #fff;
            font-size: 12px;
            margin-top: 6px;
          }
        }

        .team {
          flex: 1;
          font-size: 12px;

          div {
            height: 30px;
            padding: 4px 0;
            box-sizing: border-box;
            display: flex;
            align-items: center;
          }

          img {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            margin-right: 6px;
          }

          .span {
            color: #8C8C8C;
          }
        }

        .date {
          color: #8C8C8C;
          font-size: 14px;
          text-align: right;

          div {
            color: #000;
            height: 30px;
            line-height: 30px;
          }
        }
      }

      .but {
        background: #FCFCFD;
        border-radius: 0px 0px 4px 4px;
        display: flex;
        justify-content: space-around;
        font-size: 11px;
        padding: 10px 16px;

        div {
          width: 99px;
          height: 24px;
          background: #E5EDFF;
          border-radius: 4px;
          color: #1565FC;
          font-size: 12px;
          text-align: center;
          line-height: 24px;
        }
      }
    }
  }
}

.set-score {
  padding: 16px;

  .title {
    text-align: center;
    padding-bottom: 14px;
  }

  .score {
    .teamObj {
      width: 50%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
    }
  }

  .butscore {
    margin-top: 120px;
    background-color: rgb(63, 98, 251);
    color: #fff;
    text-align: center;
    padding: 10px 0;
    border-radius: 5px;
  }
}

.top {
  position: fixed;
  // height: 45px;
  top: 0;
  width: 100%;
  background-color: #fff;
  z-index: 999;

  .footer-box {
    overflow-x: scroll;
    white-space: nowrap;
    display: flex;
    text-align: center;
    border-top: solid 1px lightgrey;
    padding-top: 9px;
    padding-left: 16px;

    .item {
      padding: 12px 5px;
      font-size: 14px;
      box-sizing: border-box;
      font-weight: 400;
      display: flex;
      align-items: center;
      color: rgba(25, 25, 25, 0.7);
      margin-right: 4px;
    }

    .selected {
      position: relative;
      color: #000;
      font-weight: 500;
      font-size: 16px;

      &::before {
        content: '';
        position: absolute;
        width: 16px;
        height: 2px;
        background: #F95252;
        border-radius: 1px;
        bottom: 0px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    &::-webkit-scrollbar {
      /*隐藏滚轮*/
      display: none !important;
    }
  }
}

.footer {
  position: fixed;
  bottom: 0;
  background-color: #fff;
  width: 100%;
  padding: 16px 12px;
  box-sizing: border-box;

  .div {
    width: 166px;
    height: 50px;
    background: #1565FC;
    border-radius: 25px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 50px;
    box-sizing: border-box;
  }

  .delete {
    border: 1px solid #1665FC;
    color: #1565FC;
    background-color: #fff;
  }

  .delete2 {
    background-color: red;
  }
}</style>
